import axios from '../utils/axios';

/**
 * Generate AI suggestions for cron job errors
 * @param {Object} errorData - Error data containing job details and error information
 * @param {string} errorData.jobName - Name of the cron job
 * @param {string} errorData.lastError - Last error message
 * @param {string} errorData.lastFailureAt - Timestamp of last failure
 * @param {string} errorData.lastSuccessAt - Timestamp of last success
 * @param {number} errorData.consecutiveFailures - Number of consecutive failures
 * @param {number} errorData.totalRuns - Total number of runs
 * @param {number} errorData.successRate - Success rate percentage
 * @returns {Promise} API response with AI suggestions
 */
export default function generateAISuggestions(errorData) {
    // Extract admin ID from user store or context
    // For now, we'll need to get it from the calling component
    const adminId = errorData.adminId;
    
    return axios.post(`/admin/${adminId}/cron/ai-suggestions`, {
        jobName: errorData.jobName,
        lastError: errorData.lastError,
        lastFailureAt: errorData.lastFailureAt,
        lastSuccessAt: errorData.lastSuccessAt,
        consecutiveFailures: errorData.consecutiveFailures,
        totalRuns: errorData.totalRuns,
        successRate: errorData.successRate
    });
}
